// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"323":"ce58ecd5","643":"fc658745","773":"dd6b1537"}[chunkId] + ".chunk.js";
};